export function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
}

export function normalizePhoneNumber(value, countryDialCode = '') {
  const text = String(value || '').trim();
  if (!text) return '';

  const hasPlus = text.startsWith('+');
  const digits = text.replace(/[^\d]/g, '');
  if (!digits) return '';

  if (hasPlus) return `+${digits}`;

  const dialCode = String(countryDialCode || '').replace(/[^\d]/g, '');
  const nationalDigits = digits.replace(/^0+/, '');
  return dialCode ? `+${dialCode}${nationalDigits}` : nationalDigits;
}

export function friendlyFirebaseError(error) {
  const code = error?.code || '';
  const messages = {
    'auth/email-already-in-use': 'An account with this email already exists.',
    'auth/invalid-email': 'Enter a valid email address.',
    'auth/invalid-credential': 'The email or password is incorrect.',
    'auth/user-not-found': 'The email or password is incorrect.',
    'auth/wrong-password': 'The email or password is incorrect.',
    'auth/weak-password': 'Use a stronger password with at least 6 characters.',
    'auth/too-many-requests': 'Too many attempts. Please wait a moment and try again.',
    'auth/network-request-failed': 'Network error. Check your connection and try again.',
    'permission-denied': 'You do not have permission to perform this action.',
    unavailable: 'The service is temporarily unavailable. Try again.',
  };
  return messages[code] || 'Something went wrong. Please try again.';
}
